import React from 'react';
import Input from '../../Input';
import { useField } from 'react-final-form';
export default function StreetAddress({ toggleMapping, group, ...props }) {
    const {
        input: { value }
    } = useField(toggleMapping[group]?.fieldName);
    return toggleMapping[group][value] === 'show' ? <Input {...props}></Input> : null;
}
